module.exports = __webpack_public_path__ + "img/6.e0d54c20.png";